import styled from 'styled-components/native'
import { TouchableOpacity } from 'react-native'

export const StyledAvatarContainer = styled.View`
  width: 16px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const StyledTouchableAvatarContainer = styled(TouchableOpacity)`
  width: 16px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const StyledAvatar = styled.Image`
  width: 16px;
  height: 16px;
  border-radius: 8px;
`
